import { Component, OnInit } from '@angular/core';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-view-datigenerali-sede',
  templateUrl: './view-datigenerali-sede.component.html',
  styleUrls: ['./view-datigenerali-sede.component.css']
})
export class ViewDatigeneraliSedeComponent implements OnInit {

  constructor(private userComponentService: ComponentService) { }

  ngOnInit() {

    //this.userComponentService.destroyTabs();
    let tabsJson =[
      {
        id: 0,
        title: 'Dati UL',
        icon: 'user',
        component:'EmailComponent',        
  
      }      
      
    ];
  
    this.userComponentService.setTabs("tabs2",tabsJson);
    

    
  

  }
  
}
